module.exports = __webpack_public_path__ + "img/vip-level-2.1c6ff067.png";